"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const buttons_1 = require("../../../../buttons");
exports.OsmosysListLayoutReloadButton = ({ reload, loading, }) => (react_1.default.createElement(buttons_1.OsmosysButton, { osysName: "OsmosysListLayout.Reload", 
    // color="link"
    // size="lg"
    // className="text-dark"
    osysStyle: "toolbar", disabled: loading, onClick: () => {
        reload();
    }, iconSpin: loading, osysIcon: "reload", tooltip: !loading ? 'Reload' : 'Reloading...' }));
//# sourceMappingURL=ReloadButton.js.map